import { render, staticRenderFns } from "./render-background.vue?vue&type=template&id=0db02a89&scoped=true&"
import script from "./render-background.vue?vue&type=script&lang=ts&"
export * from "./render-background.vue?vue&type=script&lang=ts&"
import style0 from "./render-background.vue?vue&type=style&index=0&id=0db02a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db02a89",
  null
  
)

export default component.exports